export const GUEST_CART_KEY = "guest_cart";

export const getSessionId = () => {
  let sid = localStorage.getItem("session_id");

  if (!sid) {
    sid =
      "guest_" +
      Math.random().toString(36).substring(2) +
      Date.now().toString(36);

    localStorage.setItem("session_id", sid);
  }

  return sid;
};
